import React from 'react'

/* Components =================================================================================== */
import { Circle } from '../../../components/circle'
import { Text } from '../../../components/text/text.component'
import { Box } from '../../../components/box/box.component'

/* Styles ======================================================================================= */
import { mr8 } from '../../../styles/styleset/margin/mr8'

export type TeamMember = {
  id: {
    body: {
      name: string
      type: string
    }
  }
}

type ResourceProps = {
  resource: TeamMember
  selected?: boolean
}

const Resource = (props: ResourceProps) => {
  const { resource } = props
  const nameParts = resource.id.body.name.split(' ')
  const initials = nameParts.map((name: string) => name.charAt(0)).join('')

  return (
    <Box baseline="none" flex alignCenterY>
      <Circle baseline="background" className={mr8}>
        <Text uppercase semiBold size="xs">
          {initials}
        </Text>
      </Circle>
      <Box baseline="none" row alignCenterY style={{ flex: 1 }}>
        <Text size="sm">{resource.id.body.name}</Text>
        <Text size="xs" baseline="surface" light>
          {resource.id.body.type}
        </Text>
      </Box>
    </Box>
  )
}

export default Resource
